export default __webpack_public_path__ + "static/media/react.1585ab07.svg";